import { Color3, DynamicTexture, MeshBuilder, StandardMaterial, Vector3 } from "@babylonjs/core";

export class AxisService {

    makeTextPlane(text: string, color: string, size: number, scene) {
        if (scene) {
            var dynamicTexture = new DynamicTexture("DynamicTexture", 50, scene, true);
            dynamicTexture.hasAlpha = true;
            dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color, "transparent", true);
            var plane = MeshBuilder.CreatePlane("TextPlane", { size, updatable: true }, scene);
            plane.material = new StandardMaterial("TextPlaneMaterial", scene);
            plane.material.backFaceCulling = false;
            (plane.material as StandardMaterial).specularColor = new Color3(0, 0, 0);
            (plane.material as StandardMaterial).diffuseTexture = dynamicTexture;
            return plane;
        }
    };

    showWorldAxis(size: number, scene) {
        let axisX = MeshBuilder.CreateLines("axisX", {
            points: [
                Vector3.Zero(), new Vector3(size, 0, 0), new Vector3(size * 0.95, 0.05 * size, 0),
                new Vector3(size, 0, 0), new Vector3(size * 0.95, -0.05 * size, 0)
            ]
        }, scene);
        axisX.color = new Color3(1, 0, 0);
        let xChar = this.makeTextPlane("X", "red", size / 10, scene);
        if (xChar) {
            xChar.position = new Vector3(0.9 * size, -0.05 * size, 0);
            let axisY = MeshBuilder.CreateLines("axisY", {
                points: [
                    Vector3.Zero(), new Vector3(0, size, 0), new Vector3(-0.05 * size, size * 0.95, 0),
                    new Vector3(0, size, 0), new Vector3(0.05 * size, size * 0.95, 0)
                ]
            }, scene);
            axisY.color = new Color3(0, 1, 0);
        }

        let yChar = this.makeTextPlane("Y", "green", size / 10, scene);
        if (yChar) {
            yChar.position = new Vector3(0, 0.9 * size, -0.05 * size);
            let axisZ = MeshBuilder.CreateLines("axisZ", {
                points: [
                    Vector3.Zero(), new Vector3(0, 0, size), new Vector3(0, -0.05 * size, size * 0.95),
                    new Vector3(0, 0, size), new Vector3(0, 0.05 * size, size * 0.95)
                ]
            }, scene);
            axisZ.color = new Color3(0, 0, 1);
        }

        let zChar = this.makeTextPlane("Z", "blue", size / 10, scene);
        if (zChar) {
            zChar.position = new Vector3(0, 0.05 * size, 0.9 * size);
        }
    };

}